import { useContext } from 'react';

import { MultiMeterBarChartStore } from '../../context/MultiMeterBarChartStore.js';

export const useSetState = () => {
  const { setState } = useContext(MultiMeterBarChartStore);

  return setState;
};
